import http from "../http-common";
import { AutocompleteType } from "../types/autocomplete.type";
import { ResultsType } from "../types/results.type";
import { SearchType } from "../types/search.type";

const ObjectDataService = {
  search: (search?: SearchType) => {
    let query = '?';
    if (search) {
      if (search.search) {
        query += '&search=' + encodeURIComponent(search.search);
      }
      if (search.reference) {
        query += '&reference=' + encodeURIComponent(search.reference);
      }
      if (search.typeIds && search.typeIds.length > 0) {
        query += '&typeId=' + search.typeIds.join(',');
      }
      if (search.priceRanges && search.priceRanges.length > 0) {
        query += '&prices=' + search.priceRanges.map((priceRange) => {
          return priceRange.min + '-' + priceRange.max;
        }).join(',');
      }
      if (search.placeId) {
        query += '&placeId=' + encodeURIComponent(search.placeId);
      }
      if (search.transactions && search.transactions.length > 0) {
        query += '&transaction=' + search.transactions.map((transaction) => encodeURIComponent(transaction)).join(',');
      }
    }
    return http.get<ResultsType>("/search" + (query === '' ? '' : query));
  },
  autocomplete: (autocomplete?: AutocompleteType) => {
    let query = '?';
    if (autocomplete) {
      if (autocomplete.search) {
        query += 'search=' + encodeURIComponent(autocomplete.search);
      }
    }
    return http.get<AutocompleteType>("/autocomplete" + (query === '?' ? '' : query));
  }
}

export default ObjectDataService;
